var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-937 -399)"},[React.createElement("g",{"transform":"translate(924.895 386.895)","key":0},React.createElement("circle",{"cx":"23","cy":"23","r":"23","transform":"translate(12.105 12.105)","fill":"currentColor"})),React.createElement("path",{"d":"M21.709,10.283h-9.14V1.143a1.143,1.143,0,0,0-2.285,0v9.141H1.143a1.143,1.143,0,0,0,0,2.285h9.141v9.14a1.143,1.143,0,1,0,2.285,0v-9.14h9.14a1.143,1.143,0,1,0,0-2.285Zm0,0","transform":"translate(948.574 410.574)","fill":"#fff","key":1})]));
}

Plus.defaultProps = {"viewBox":"0 0 46 46"};

module.exports = Plus;

Plus.default = Plus;
